import { createContext, type RefObject } from 'react';
import type { NetworkEngineRef } from './NetworkEngine';

/**
 * Provides access to the persistent NetworkEngine canvas
 * from any component in the tree.
 */
export const NetworkEngineContext = createContext<RefObject<NetworkEngineRef | null> | null>(null);
